<template>
    <div class="basic" style="height: calc(100% - 40px);">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span>监测点管理</span>
        </div>
        <div> 
          <el-button type="primary" @click="addMonitor" v-if="isAuth('basicData:insertMonitorInfo') && !noBuilding">新建监测点</el-button>
          <div v-else-if="isAuth('basicData:insertMonitorInfo') && noBuilding" style="width:90px;height:30px;background:#f5f5f5;color:#c9c9c9;font-size:13px;text-align:center;">新建监测点</div>
        </div>

        <!-- <div @click.stop="addMonitor3D" class="addMon3d" >3D配置</div> -->
      </div>
      <div v-if="noBuilding == true" class="fixedScorll Notips" :style="{height: heightCard + 'px'}">当前无建筑，请前往建筑管理页面&nbsp;<a @click="editBuilding" v-show="isAuth('basicData:insertBuildInfo')"> 添加 </a></div>
      <div v-else class="fixedScorll" :style="{height: heightCard + 'px'}">
        <div class="maindetails">
          <div>
            <div class="detailsName"> 
              <span>建筑名称:</span>&nbsp;&nbsp;
              <span>{{this.BuildingDatil.buildingName}}</span>
            </div>
              <div class="detailsDevice">
              <span>监测设备数:</span>&nbsp;&nbsp;
              <span>{{this.deviceNum}} (启用) </span> <span style="display:inlin-block;margin:10px;">|</span><span> {{this.failCount}} (禁用)</span>
            </div>
          </div>
          <div class="detailAddress">
              <span>建筑地址:</span>&nbsp;&nbsp;
              <span v-html="this.BuildingDatil.address"></span>
          </div>
        </div>
        <todo-List :pageActive="pageActive" :tabArray="tabArray" :detailsArray="detailsArray" :style="{height: heightBg + 1 + 'px'}" @listenType="listenType" @listenSearch="listenSearch" @listenSeav="listenSeav"></todo-List>
      </div>
    </div>
</template>
<script>
    import todoList from "@/components/todoList";
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'BasicData',
        components: {
            todoList
        },
        inject:['reload'],
        data() {
            return {
                pageActive: '4-1',
                heightCard:'',
                heightBg:'',
                parms:{
                  customerId:'',
                  buildingId:'',
                  runStatus:[],
                  connectStatus:[],
                  searchName:"",
                  deviceStatus:[],
                  type:[],
                  enabled:[]
                },
                tabArray:[], //Tab选项值
                BuildingDatil:{
                  buildingName:'',
                  detailAddress:''
                },
                deviceNum:'',
                failCount:'',
                detailsArray:[],
                windowResize:null,
                noBuilding:false,
            }
        },
        computed:{
          getMap() {
            return this.$store.state.buildingId
          },
          navTopMsg(){
            return this.$store.state.navTopMsg
          }
        },
        watch: {
          navTopMsg(val){
            this.getTabListAtax();//获取TAB设备类型
            this.getDetailsList(); //获取详情信息
          },
          getMap (val) { // status的变化，然后执行操作
            sessionStorage.setItem('tabValue',0); //重置搜索
            this.reload();
            this.parms.deviceStatus = []
            this.parms.runStatus = []
            this.parms.connectStatus = []
            this.parms.enabled = []
          }
        },
        created() {
            this.detailsArray = false;
            sessionStorage.setItem('complete',true) //左侧导航判断内容是否填写完整

          this.getLeftBuilding('1');
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true);
                that.isScroll();
            };
          that.windowResize();
          window.addEventListener('resize',that.windowResize);
        },
        methods: {
          getLeftBuilding(a) {
            let params = {
              buildingName: '',
              target: a,
              customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
            };
                   if(sessionStorage.getItem('userType') == '0'){ //如果集团进入target置空
             params.target ='';
             params.customerId =sessionStorage.getItem('bureaucustomerId');
       }
            ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
              sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
              if(res.data.data.length>0){
                if(res.data.data[0].children.length===0){
                    this.noBuilding=true;
                }
              }
              this.$store.dispatch("getLeftDataList", res.data.data);
              if(this.isAuth('common:interface')){
                this.getTabListAtax();//获取TAB设备类型
              }
              if(sessionStorage.getItem('ruleFormOption') && sessionStorage.getItem('returnType') == '1'){
                let ruleFormOption = JSON.parse(sessionStorage.getItem('ruleFormOption'));
                if(ruleFormOption){
                    this.parms.deviceStatus = ruleFormOption.deviceStatusVal; //赋值Type选择值
                    this.parms.runStatus = ruleFormOption.monitorStateVal; //赋值Type选择值
                    this.parms.connectStatus = ruleFormOption.communicationStateVal; //赋值Type选择值
                    this.parms.enabled = ruleFormOption.pointStateVal; //赋值Type选择值
                    this.getDetailsList();
                 }
              }else{
                this.getDetailsList(); //获取详情信息
              }
            })
          },
        editBuilding() {
            let from = {
                buildingName: '',
                area: '',
                address: [],
                onFloor: '',
                underFloor: '',
                coverArea: '',
                detailAddress: '',
            }
            sessionStorage.setItem('editBulitData',JSON.stringify(from));
            this.$store.state.editBulitData = from;
            this.$router.push({path:'/content/editBuliting'});
            sessionStorage.setItem('saveBtn',true);
            this.$store.state.saveBtn = true;
          },
          initFont(){
            let that = this;
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true);
                that.isScroll();
          },
          addMonitor(){ //新建检测点跳转
            this.$router.push({path:'/content/addMonitor',query:{IStrue:'false'}}); //进入非监测点详情页
          },
          addMonitor3D(){
            this.$router.push({path:'/content/addView'} ); //进入3d配置
          },
          listenType(data){ //监听子组件Tab
            if(data == '0'){
              this.parms.type = []; //赋值Type选择值
            }else{
              this.parms.type = data; //赋值Type选择值
            }
            this.getTabListAtax();//获取TAB设备类型
            this.getDetailsList();
          },
          listenSearch(data){//子:失去焦点查询
            this.parms.searchName = data; //赋值Type选择值
            this.getDetailsList();
          },
          listenSeav(data){ //监听子组件保存
           this.parms.deviceStatus = data.deviceStatusVal; //赋值Type选择值
           this.parms.runStatus = data.monitorStateVal; //赋值Type选择值
           this.parms.connectStatus = data.communicationStateVal; //赋值Type选择值
           this.parms.enabled = data.pointStateVal; //赋值Type选择值
           this.getDetailsList();
          },
          getTabListAtax(){ //获取Tab列表选项
              let parms = {
                      buildingId:'',//赋值建筑id
                      customerId: sessionStorage.getItem("customerId"),//赋值客户id
                      target: '1',
                  };
              if(sessionStorage.getItem("buildingId")){
                parms.buildingId=sessionStorage.getItem("buildingId")
              }else {
                if(this.$store.state.leftMonitorInfo[0].children.length>0){
                  parms.buildingId=this.$store.state.leftMonitorInfo[0].children[0].id;
                  sessionStorage.setItem('buildingId',this.$store.state.leftMonitorInfo[0].children[0].id);
                }else {
                  parms.buildingId='';
                }
              }
                  ajaxFuncJson('/basicData/getMonitorType',parms).then(res=>{
                      if(res.data.status == 200){
                         this.tabArray = [];//先清空
                         this.tabArray = res.data.data; //获取Tab列表选项
                         let totalNum = 0;
                         this.tabArray.forEach((a,b)=>{
                               totalNum += a.warnNum;
                         })
                        let Objective = {
                            flag: true,
                            name: "全部",
                            type: '',
                            warnNum: totalNum,
                          }
                        this.tabArray.unshift(Objective);
                      }
                  })
          },
          getDetailsList(){ //获取详情
              if(this.isAuth('common:interface')) {
                if(sessionStorage.getItem("buildingId")){
                  this.parms.buildingId = sessionStorage.getItem("buildingId");//赋值建筑id
                }else {
                  if(this.$store.state.leftMonitorInfo[0].children.length>0){
                    this.parms.buildingId =this.$store.state.leftMonitorInfo[0].children[0].id;//赋值建筑id
                  }else {
                    this.parms.buildingId='';
                  }
                }
                this.parms.customerId = sessionStorage.getItem("customerId");//赋值客户id
                this.parms.target = '1';
                ajaxFuncJson('/basicData/getMonitorByMultipleMatching',this.parms).then(res=>{
                    if(res.data.status == 200){
                        let analysis= res.data.data;
                        if(analysis.BuildingDatil){
                          this.BuildingDatil = analysis.BuildingDatil; //赋值监测点详情
                                                         if(this.BuildingDatil.address == this.BuildingDatil.detailAddress){
                                    this.BuildingDatil.address = (this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }else{
                                    this.BuildingDatil.address = (this.BuildingDatil.address +'|'+ this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }
                        }else{
                           this.BuildingDatil.buildingName = '';
                           this.BuildingDatil.address= '';
                        }
                        this.deviceNum = analysis.deviceNum; //赋值监测点详情
                        this.failCount = analysis.failCount; //赋值监测点详情
                        this.detailsArray = analysis.monitorByMultipleMatching; //赋值监测点详情
                        this.isScroll();
                    }
                })
              }
          },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                  cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                  document.getElementsByClassName('maindetails')[0].style.marginRight=0;
                  document.getElementsByClassName('mainList')[0].style.marginRight=0;
              }else {
                document.getElementsByClassName('maindetails')[0].style.marginRight='1.05%';
                document.getElementsByClassName('mainList')[0].style.marginRight='1.05%';
              }
            });
          }
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .el-main{  // 内容布局
    width: 78.1%;
    margin:10px 0 7px 1.05%;
    padding: 0;
    }
    .el-main  .maindetails{
    height: 118px;
    padding: 30px 40px;
    margin: 10px 0;
    margin-right: 1.05%;
    background-color: #fff;
    font-size: $fontSizeThree;
    line-height: 14px;
    color: #282828;
    &>div:first-child{
    @include flexible;
      .detailsName>span:last-child{
        display: inline-block;
        width: 280px;
        vertical-align: middle;
        @include textOverflow
      }
      .detailsDevice{
        margin-left: 100px;
        height: 15px;
        line-height: 15px;
      }
    }
      .detailAddress{
        margin-top: 30px;
        height: 15px;
        line-height: 15px;
      }
    }
    .Notips{
      @include flexible;
      @include alignItems(center);
      @include justify(center);
      font-size: 18px;
      color: #282828;
      &>a{
        color:#198cff;
        cursor: pointer;
      }
      &>a:hover{
        text-decoration:underline
      }
    }
    .addMon3d{
      cursor:pointer; 
      width:90px;
      height:30px;
      font-size:13px;
      text-align:center;
      position: absolute;
      top: 14px;
      right: 120px;
      background-color: #198cff !important;
      color: #fff;
      border-radius: 3px;
      font-weight: 500; 
    }
    .addMon3d:hover{
          background-color: #3399ff !important
    }

</style>



// WEBPACK FOOTER //
// src/page/BasicData/index.vue